import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

/** Keyboard-shortcut pill used on inspector more-menus and the editor context menu. */
export const KeyboardShortcutHint = styled('div', ({ $disabled }: { $disabled?: boolean }) => ({
  display: 'flex',
  padding: '1px 5px',
  alignItems: 'flex-start',
  gap: '10px',
  borderRadius: '4px',
  background: lightTheme.colors.grayScale50,
  ...lightTheme.typography.Small12medium,
  color: $disabled ? '#ccc' : lightTheme.colors.blackGray,
  letterSpacing: '-0.6px',
}))
